import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import styles from './FAQAccordion.module.css';

/**
 * Shared FAQ accordion. Same behavior as the Social Dallas "+" toggle pattern.
 */
export default function FAQAccordion({ items, defaultOpen = -1 }) {
  const [openIdx, setOpenIdx] = useState(defaultOpen);

  return (
    <ol className={styles.list}>
      {items.map((item, i) => (
        <FAQItem
          key={i}
          index={i}
          q={item.q}
          a={item.a}
          open={openIdx === i}
          onToggle={() => setOpenIdx(openIdx === i ? -1 : i)}
        />
      ))}
    </ol>
  );
}

function FAQItem({ index, q, a, open, onToggle }) {
  return (
    <li className={`${styles.item} ${open ? styles.itemOpen : ''}`}>
      <button className={styles.row} onClick={onToggle} aria-expanded={open}>
        <span className={styles.q}>{q}</span>
        <span className={styles.plus} aria-hidden="true">
          <span className={styles.plusBar} />
          <span className={`${styles.plusBar} ${styles.plusBarV} ${open ? styles.plusBarVHide : ''}`} />
        </span>
      </button>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            className={styles.answer}
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
          >
            <p>{a}</p>
          </motion.div>
        )}
      </AnimatePresence>
    </li>
  );
}
